export { default } from "./Calendar"

import { default as Daily } from "./Daily"
import { default as Grid } from "./Grid"

export const Views = { Daily, Grid }
